import { del, get, post, put } from '@api/request';

export const fetchContacts = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/contacts`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const createContact = async (
  { assessmentService },
  authenticationToken,
  { taxingUnitID, payload },
) => {
  const url = `${assessmentService}/assessment/taxingunit/${taxingUnitID}/contacts`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const updateContact = async (
  { assessmentService },
  authenticationToken,
  { payload },
) => {
  const { taxingUnitContactID } = payload;
  const url = `${assessmentService}/assessment/taxingunit/contact/${taxingUnitContactID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
};

export const deleteContact = async (
  { assessmentService },
  authenticationToken,
  { payload: { taxingUnitContactID } },
) => {
  const url = `${assessmentService}/assessment/taxingunit/contact/${taxingUnitContactID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};
